/**
 * Cuánto hace que pasó algo, en palabras.
 *
 * Vive fuera del componente porque es lo único ahí que tiene bordes: 59 minutos
 * todavía es «recién», 60 ya es una hora, y **un día va en singular**. Nada de
 * eso se ve mirando la pantalla —un «hace 1 días» se lee como un error de otro
 * lado— y tampoco falla: sale un texto raro y sigue.
 */
export function hace(iso: string): string {
  const minutos = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (minutos < 60) return "recién";
  const horas = Math.floor(minutos / 60);
  if (horas < 24) return `hace ${horas} h`;
  const dias = Math.floor(horas / 24);
  return dias === 1 ? "hace 1 día" : `hace ${dias} días`;
}

/**
 * Cuánto FALTA para algo, en palabras — el `formatDistanceToNow` con
 * `addSuffix` que `imprenta` usa para el vencimiento de una invitación.
 *
 * Lo vencido se dice vencido y no «en -2 días»: una invitación que expiró es lo
 * que hay que reenviar, y un número negativo no lo dice.
 */
export function faltan(iso: string, ahora: number = Date.now()): string {
  const minutos = Math.floor((new Date(iso).getTime() - ahora) / 60000);
  if (minutos <= 0) return "vencida";
  if (minutos < 60) return `en ${minutos} min`;
  const horas = Math.floor(minutos / 60);
  if (horas < 24) return horas === 1 ? "en 1 h" : `en ${horas} h`;
  const dias = Math.floor(horas / 24);
  return dias === 1 ? "en 1 día" : `en ${dias} días`;
}
